import React, { useState } from "react";
import classnames from "classnames";
import {
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import EvseList from "./EvseList";
import ComponentList from "./ComponentList";
import StationReservation from "./StationReservation";
import StationDetails from "./StationDetails";
import UsageHistory from "./UsageHistory";
import QRCodeView from "./QRCodeView";

const ViewStation = ({ values }) => {
  const [activeTab, setActiveTab] = useState("1");
  return (
    <>
      <CardHeader>
        <div className="d-flex align-items-center justify-content-between">
          <Nav
            className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
            role="tablist"
          >
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => {
                  setActiveTab("1");
                }}
              >
                <i className="fas fa-home"></i>
                Details
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => {
                  setActiveTab("2");
                }}
              >
                <i className="fas fa-home"></i>
                EVSE List
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "3" })}
                onClick={() => {
                  setActiveTab("3");
                }}
              >
                <i className="fas fa-home"></i>
                Component
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "4" })}
                onClick={() => {
                  setActiveTab("4");
                }}
              >
                <i className="fas fa-home"></i>
                Reservation
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "5" })}
                onClick={() => {
                  setActiveTab("5");
                }}
              >
                <i className="fas fa-home"></i>
                Usage History
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "6" })}
                onClick={() => {
                  setActiveTab("6");
                }}
              >
                <i className="fas fa-home"></i>
                Pricing Group
              </NavLink>
            </NavItem>
          </Nav>
        </div>
      </CardHeader>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <StationDetails values={values} />
        </TabPane>
        <TabPane tabId="2">
          <EvseList stationID={values?.stationID} />
        </TabPane>
        <TabPane tabId="3">
          <ComponentList />
        </TabPane>
        <TabPane tabId="4">
          <StationReservation stationID={values?.stationID} />
        </TabPane>
        <TabPane tabId="5">
          <UsageHistory stationID={values?.stationID} activeTab={activeTab} />
        </TabPane>
        <TabPane tabId="6">
           <QRCodeView values={values} />
        </TabPane>
      </TabContent>
    </>
  );
};

export default ViewStation;
